const menu = {
    list() {
        return [
            {
              "backMenu": [
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-time",
                      "buttons": [
                        "查看",
                        "删除"
                      ],
                      "menu": "教练预约",
                      "menuJump": "列表",
                      "tableName": "jiaolianyuyue"
                    }
                  ],
                  "menu": "教练预约管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-paint",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "用户",
                      "menuJump": "列表",
                      "tableName": "yonghu"
                    },
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "查看",
                        "购买"
                      ],
                      "menu": "VIP用户",
                      "menuJump": "列表",
                      "tableName": "vipyonghu"
                    }
                  ],
                  "menu": "用户管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-present",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "教练",
                      "menuJump": "列表",
                      "tableName": "jiaolian"
                    }
                    // {
                    //   "appFrontIcon": "cuIcon-present",
                    //   "buttons": [
                    //     "新增",
                    //     "查看",
                    //     "修改",
                    //     "删除"
                    //   ],
                    //   "menu": "教练状态",
                    //   "menuJump": "列表",
                    //   "tableName": "coachstatus"
                    // }
                  ],
                  "menu": "教练管理"
                },
                 {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-time",
                      "buttons": [
                        "查看",
                        "删除",
                        "审核"
                      ],
                      "menu": "设置教练空闲时间",
                      "menuJump": "列表",
                      "tableName": "allCoachesAvailability"
                    }
                  ],
                  "menu": "教练排班"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-present",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除",
                        "查看评论"
                      ],
                      "menu": "健身项目",
                      "menuJump": "列表",
                      "tableName": "jianshenxiangmu"
                    }
                  ],
                  "menu": "健身项目管理"
                },
                 {
                  "child": [
                   
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看",
                        "处理"
                      ],
                      "menu": "散客付款",
                      "menuJump": "列表",
                      "tableName": "cashier"
                    },
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看",
                        "处理"
                      ],
                      "menu": "散客预约支付记录",
                      "menuJump": "列表",
                      "tableName": "paymentrecord"
                    },

                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看",
                        "处理"
                      ],
                      "menu": "线上到店付款",
                      "menuJump": "列表",
                      "tableName": "offlinepayment"
                    },
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "线上未付款记录",
                      "menuJump": "列表",
                      "tableName": "appointment-unpaid"
                    },
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "线上付款记录",
                      "menuJump": "列表",
                      "tableName": "appointment-paid"
                    }
                  ],
                  "menu": "付款管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-news",
                      "buttons": [
                        "新增",
                        "查看",
                        "删除"
                      ],
                      "menu": "消息管理",
                      "menuJump": "列表",
                      "tableName": "notification"
                    }
                    
                  ],
                  "menu": "消息管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-camera",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "项目分类",
                      "menuJump": "列表",
                      "tableName": "xiangmufenlei"
                    }
                  ],
                  "menu": "项目分类管理"
                },
                {
                  "child": [
                   
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看",
                        "处理"
                      ],
                      "menu": "出入库记录",
                      "menuJump": "列表",
                      "tableName": "inventory"
                    },
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看",
                        "处理"
                      ],
                      "menu": "库存盘点",
                      "menuJump": "列表",
                      "tableName": "inoutventory"
                    },

                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看",
                        "处理"
                      ],
                      "menu": "商品出入库",
                      "menuJump": "列表",
                      "tableName": "product"
                    },
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "销售记录",
                      "menuJump": "列表",
                      "tableName": "saleorder"
                    }
                  ],
                  "menu": "库存管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "查看",
                        "删除",
                        "查看评论"
                      ],
                      "menu": "提成规则",
                      "menuJump": "列表",
                      "tableName": "commission"
                    },
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "查看",
                        "删除",
                        "查看评论"
                      ],
                      "menu": "员工销售商品提成记录",
                      "menuJump": "列表",
                      "tableName": "commissionlist"
                    }
                  ],
                  "menu": "员工提成管理"
                },
                // {
                //   "child": [
                //     {
                //       "appFrontIcon": "cuIcon-time",
                //       "buttons": [
                //         "查看",
                //         "删除"
                //       ],
                //       "menu": "教练预约",
                //       "menuJump": "列表",
                //       "tableName": "jiaolianyuyue"
                //     }
                //   ],
                //   "menu": "教练预约管理"
                // },
                {
                  "child": [
                    
                    {
                      "appFrontIcon": "cuIcon-list",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "升级类型设置",
                      "menuJump": "列表",
                      "tableName": "upgraderule"
                    },
                    {
                      "appFrontIcon": "cuIcon-similar",
                      "buttons": [
                        "查看",
                        "新增",
                        "删除"
                      ],
                      "menu": "升级添加",
                      "menuJump": "列表",
                      "tableName": "upgrade-add"
                    },
                    {
                      "appFrontIcon": "cuIcon-form",
                      "buttons": [
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "升级订单列表",
                      "menuJump": "列表",
                      "tableName": "upgrade"
                    }
                  ],
                  "menu": "升级管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-wenzi",
                      "buttons": [
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "轮播图管理",
                      "tableName": "config"
                    },
                    {
                      "appFrontIcon": "cuIcon-wenzi",
                      "buttons": [
                        "查看",
                        "修改"
                      ],
                      "menu": "主页管理",
                      "tableName": "homepage-config"
                    },
                    {
                      "appFrontIcon": "cuIcon-news",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "健身资讯",
                      "tableName": "news"
                    }
                  ],
                  "menu": "系统管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "用户充值",
                      "tableName": "recharge"
                    },
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "充值记录",
                      "tableName": "rechargeList"
                    },
                    {
                      "appFrontIcon": "cuIcon-settings",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "充值规则",
                      "menuJump": "列表",
                      "tableName": "chongzhiguize"
                    },
                   
                  ],
                  "menu": "充值促销管理"
                },
                {
                  "child": [
                    
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "VIP管理",
                      "tableName": "viprule"
                    },
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "新增"
                      ],
                      "menu": "VIP购买",
                      "tableName": "vippurchase"
                    },
                    {
                      "appFrontIcon": "cuIcon-form",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "VIP记录",
                      "menuJump": "列表",
                      "tableName": "viporder"
                    }
                  ],
                  "menu": "VIP管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-form",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "GiftCard生成",
                      "menuJump": "列表",
                      "tableName": "giftcard"
                    },
                    {
                      "appFrontIcon": "cuIcon-form",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "GiftCard购买",
                      "menuJump": "列表",
                      "tableName": "giftcardpurchase"
                    },
                    {
                      "appFrontIcon": "cuIcon-form",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "GiftCard记录",
                      "menuJump": "列表",
                      "tableName": "giftcardorder"
                    }
                  ],
                  "menu": "GiftCard管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-refund",
                      "buttons": [
                        "查看",
                        "处理"
                      ],
                      "menu": "退款处理",
                      "menuJump": "列表",
                      "tableName": "refund"
                    }
                  ],
                  "menu": "退款管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-home",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "房间管理",
                      "menuJump": "列表",
                      "tableName": "room"
                    },
                    {
                      "appFrontIcon": "cuIcon-calendar",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "房间日历",
                      "menuJump": "列表",
                      "tableName": "roomcalendar"
                    },
                    {
                      "appFrontIcon": "cuIcon-clean",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "清洁计划",
                      "menuJump": "列表",
                      "tableName": "roomcleaning"
                    }
                  ],
                  "menu": "场控管理"
                },
               
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "店铺",
                      "menuJump": "列表",
                      "tableName": "shop"
                    }
                  ],
                  "menu": "店铺管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-money",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "店铺教练绑定",
                      "menuJump": "列表",
                      "tableName": "shopcoach"
                    }
                  ],
                  "menu": "店铺教练管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-present",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "文档管理",
                      "menuJump": "列表",
                      "tableName": "document"
                    },
                    {
                      "appFrontIcon": "cuIcon-present",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "教练文档管理",
                      "menuJump": "列表",
                      "tableName": "documentcoach"
                    }
                  ],
                  "menu": "文档中心"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-present",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "教练空闲时间模式",
                      "menuJump": "列表",
                      "tableName": "jiaolianzidonggengxin"
                    }
                  ],
                  "menu": "教练自动添加空闲时间模式设置"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-present",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "统计",
                      "menuJump": "列表",
                      "tableName": "dashboard"
                    },
                    {
                      "appFrontIcon": "cuIcon-present",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "member分析",
                      "menuJump": "列表",
                      "tableName": "memeber-analysis"
                    },
                    {
                      "appFrontIcon": "cuIcon-present",
                      "buttons": [
                        "查看",
                        "新增",
                        "修改",
                        "删除"
                      ],
                      "menu": "分析中心",
                      "menuJump": "列表",
                      "tableName": "report-center"
                    }
                  ],
                  "menu": "统计"
                }
              ],
              "frontMenu": [
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "健身项目列表",
                      "menuJump": "列表",
                      "tableName": "jianshenxiangmu"
                    }
                  ],
                  "menu": "健身项目模块"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-time",
                      "buttons": [
                        "查看",
                        "预约"
                      ],
                      "menu": "教练信息列表",
                      "menuJump": "列表",
                      "tableName": "jiaolianxinxi"
                    }
                  ],
                  "menu": "教练信息模块"
                }
              ],
              "hasBackLogin": "是",
              "hasBackRegister": "否",
              "hasFrontLogin": "否",
              "hasFrontRegister": "否",
              "roleName": "管理员",
              "tableName": "users"
            },
            {
              "backMenu": [
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-time",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "教练预约",
                      "menuJump": "列表",
                      "tableName": "jiaolianyuyue"
                    }
                  ],
                  "menu": "教练预约管理"
                }
              ],
              "frontMenu": [
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "健身项目列表",
                      "menuJump": "列表",
                      "tableName": "jianshenxiangmu"
                    }
                  ],
                  "menu": "健身项目模块"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-time",
                      "buttons": [
                        "查看",
                        "预约"
                      ],
                      "menu": "教练信息列表",
                      "menuJump": "列表",
                      "tableName": "jiaolianxinxi"
                    }
                  ],
                  "menu": "教练信息模块"
                }
              ],
              "hasBackLogin": "否",
              "hasBackRegister": "否",
              "hasFrontLogin": "是",
              "hasFrontRegister": "是",
              "roleName": "用户",
              "tableName": "yonghu"
            },
            {
              "backMenu": [
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除",
                        "查看评论"
                      ],
                      "menu": "教练信息",
                      "menuJump": "列表",
                      "tableName": "jiaolianxinxi"
                    }
                  ],
                  "menu": "教练信息管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-time",
                      "buttons": [
                        "查看",
                        "删除",
                        "审核"
                      ],
                      "menu": "教练预约",
                      "menuJump": "列表",
                      "tableName": "jiaolianyuyue"
                    }
                  ],
                  "menu": "教练预约管理"
                },
                {
                    "child": [
                      {
                        "appFrontIcon": "cuIcon-time",
                        "buttons": [
                          "查看",
                          "删除",
                          "审核"
                        ],
                        "menu": "空闲时间",
                        "menuJump": "列表",
                        "tableName": "availability"
                      },
                      {
                        "appFrontIcon": "cuIcon-time",
                        "buttons": [
                          "查看",
                          "删除",
                          "审核"
                        ],
                        "menu": "添加空闲时间",
                        "menuJump": "列表",
                        "tableName": "setAvailability"
                      }
                    ],
                    "menu": "教练空闲时间"
                  }
              ],
              "frontMenu": [
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "查看"
                      ],
                      "menu": "健身项目列表",
                      "menuJump": "列表",
                      "tableName": "jianshenxiangmu"
                    }
                  ],
                  "menu": "健身项目模块"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-time",
                      "buttons": [
                        "查看",
                        "预约"
                      ],
                      "menu": "教练信息列表",
                      "menuJump": "列表",
                      "tableName": "jiaolianxinxi"
                    }
                  ],
                  "menu": "教练信息模块"
                }
              ],
              "hasBackLogin": "是",
              "hasBackRegister": "是",
              "hasFrontLogin": "否",
              "hasFrontRegister": "否",
              "roleName": "教练",
              "tableName": "jiaolian"
            },
            {
              "backMenu": [
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "健身项目",
                      "menuJump": "列表",
                      "tableName": "jianshenxiangmu"
                    }
                  ],
                  "menu": "健身项目管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除",
                        "查看评论"
                      ],
                      "menu": "教练信息",
                      "menuJump": "列表",
                      "tableName": "jiaolianxinxi"
                    }
                  ],
                  "menu": "教练信息管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-time",
                      "buttons": [
                        "查看",
                        "删除",
                        "审核"
                      ],
                      "menu": "教练预约",
                      "menuJump": "列表",
                      "tableName": "jiaolianyuyue"
                    }
                  ],
                  "menu": "教练预约管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "用户管理",
                      "menuJump": "列表",
                      "tableName": "yonghu"
                    }
                  ],
                  "menu": "用户管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-vip",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "教练管理",
                      "menuJump": "列表",
                      "tableName": "jiaolian"
                    }
                  ],
                  "menu": "教练管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-shop",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "门店管理",
                      "menuJump": "列表",
                      "tableName": "shop"
                    }
                  ],
                  "menu": "门店管理"
                },
                {
                  "child": [
                    {
                      "appFrontIcon": "cuIcon-admin",
                      "buttons": [
                        "新增",
                        "查看",
                        "修改",
                        "删除"
                      ],
                      "menu": "管理员管理",
                      "menuJump": "列表",
                      "tableName": "tenantAdmin"
                    }
                  ],
                  "menu": "管理员管理"
                }
              ],
              "frontMenu": [],
              "hasBackLogin": "是",
              "hasBackRegister": "否",
              "hasFrontLogin": "否",
              "hasFrontRegister": "否",
              "roleName": "租户管理员",
              "tableName": "tenantAdmin"
            }
          ]
    }
}
export default menu;